import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CreateFollowUpDto,
  CreateFollowUpPhraseDto,
  FollowUpItem,
  FollowUpPageResult,
  FollowUpPhraseItem,
  FollowUpQueryParams,
  UpdateFollowUpDto,
  UpdateFollowUpPhraseDto,
} from './types/follow-up';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/follow-ups';
const PHRASE_PATH = '/bff/zy-crm/follow-up-phrases';

export async function queryFollowUps(params: FollowUpQueryParams, options?: ApiRequestOptions) {
  return request<FollowUpPageResult>(BASE_PATH, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function createFollowUp(payload: CreateFollowUpDto, options?: ApiRequestOptions) {
  return request<FollowUpItem>(BASE_PATH, {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateFollowUp(
  uuid: string,
  payload: UpdateFollowUpDto,
  options?: ApiRequestOptions,
) {
  return request<FollowUpItem>(`${BASE_PATH}/${uuid}`, {
    method: 'PATCH',
    data: payload,
    ...(options || {}),
  });
}

export async function deleteFollowUp(uuid: string, options?: ApiRequestOptions) {
  return request<{ uuid: string; deleted: boolean }>(`${BASE_PATH}/${uuid}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

export async function queryFollowUpPhrases(options?: ApiRequestOptions) {
  return request<FollowUpPhraseItem[]>(PHRASE_PATH, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createFollowUpPhrase(
  payload: CreateFollowUpPhraseDto,
  options?: ApiRequestOptions,
) {
  return request<FollowUpPhraseItem>(PHRASE_PATH, {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateFollowUpPhrase(
  uuid: string,
  payload: UpdateFollowUpPhraseDto,
  options?: ApiRequestOptions,
) {
  return request<FollowUpPhraseItem>(`${PHRASE_PATH}/${uuid}`, {
    method: 'PATCH',
    data: payload,
    ...(options || {}),
  });
}

export async function deleteFollowUpPhrase(uuid: string, options?: ApiRequestOptions) {
  return request<{ uuid: string; deleted: boolean }>(`${PHRASE_PATH}/${uuid}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

export async function reorderFollowUpPhrases(uuids: string[], options?: ApiRequestOptions) {
  return request<FollowUpPhraseItem[]>(`${PHRASE_PATH}/reorder`, {
    method: 'PATCH',
    data: { uuids },
    ...(options || {}),
  });
}
